import React from 'react';
import { Switch } from 'react-router-dom';
import { bool, func, number, object, shape, string } from 'prop-types';

import Iframe from '../../containers/Iframe/Iframe';
import { DefaultLayoutRoute } from '../../containers/App';

const MERIT_ROUTE = 'merit';
export const IFRAME_PATH = '/iframe';
export const MERIT_IFRAME_ROUTES = [
  {
    path: 'pricing2/price',
    subRoutes: ['/jobs/:jobId(.*)/compensation-summary-report']
  },
  {
    path: 'pcenter',
    subRoutes: ['pcenter', 'pcenter-2', 'pcenter-reports']
  },
  {
    path: 'merit-admin/slu/slu'
  },
  {
    path: 'structures/strucselect/structure-select',
    subRoutes: ['/jobs/:jobId/compensation-summary-report']
  }
];

export default function MeritIframeRoutes({ layoutProps, componentProps, location }) {
  const routes = MERIT_IFRAME_ROUTES.map(route => {
    let path = getMeritPath(route.path);
    if (route.subRoutes) {
      const subRouteRegexMatch = route.subRoutes.join('|');
      path += `/:subroute(${subRouteRegexMatch})`;
    }
    return (
      <DefaultLayoutRoute
        key={`merit_route_${route.path}`}
        path={path}
        component={route.component ? route.component : Iframe}
        componentProps={componentProps}
        layoutProps={layoutProps}
      />
    );
  });
  routes.push(
    <DefaultLayoutRoute
      key={`merit_route_default`}
      path={`${IFRAME_PATH}/:meritroute?/:path(.*)`}
      component={Iframe}
      componentProps={componentProps}
      layoutProps={layoutProps}
    />
  );
  return <Switch location={location}>{routes}</Switch>;
}

function getMeritPath(routePath) {
  return `${IFRAME_PATH}/:meritroute(${MERIT_ROUTE})/:path(${routePath})`;
}
